
  import {prepareImageUrl} from '@/helper/ImageHelper';
  export default {
    name: 'SectionHeadlineWithTextAndImageV2',
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      return 'section-headline-with-text-and-image-v2-' + props.section.id;
    },
    data() {
      return {
        imageUrl: '',
        sizeOfImageColumn: 0,
      };
    },
    computed: {
      customWidth() {
        const percentage = (this.sizeOfImageColumn / 12) * 100;
        return this.$vuetify.breakpoint.width <=
          this.$vuetify.breakpoint.thresholds.sm
          ? '100%'
          : percentage + '%';
      },
    },
    created() {
      this.imageUrl = this.section.image
        ? prepareImageUrl(this.section.image.url)
        : '';
      this.sizeOfImageColumn = this.section.image_width
        ? Number(this.section.image_width.split('_')[1])
        : 6;
    },
    methods: {
      getSectionColor() {
        let color = '#0D223F';
        if (this.section.background_color === 'white') {
          color = 'white';
        }
        if (this.section.background_color === 'gray') {
          color = '#f2f2f2';
        }
        return color;
      },
    },
  };
